import { render, staticRenderFns } from "./RelatedDocSearchResultItem.vue?vue&type=template&id=aa6d20c6"
import script from "./RelatedDocSearchResultItem.vue?vue&type=script&lang=ts"
export * from "./RelatedDocSearchResultItem.vue?vue&type=script&lang=ts"
import style0 from "./RelatedDocSearchResultItem.vue?vue&type=style&index=0&id=aa6d20c6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports